module.exports = __webpack_public_path__ + "static/media/C1en.7b26dbe2.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C1en.png
// module id = 893
// module chunks = 0